import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { ButtonTypes } from '@app/shared/enums/buttonTypes.enum';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit {
  constructor() {}

  buttonTypesEnum = ButtonTypes;

  @Output() clickEmitter = new EventEmitter();

  @Input() type:string = this.buttonTypesEnum.PRIMARY;
  @Input() text = 'Call to Action';
  @Input() disabled = false;

  emitClick() {
    this.clickEmitter.emit();
  }

  ngOnInit(): void {
  }
}
